import type { TFunction } from 'i18next';

// Journeys whose actions can be executed by the floating fleet-manager chat
// via write tools (scheduling, drivers, groups, checklists, places, camera
// configs, fleet event sensibility, user invites). Maps the journey ID
// (kebab-case, matches route/identifier shapes) to its snake_case English
// translation key under `floating_chat_prompts.*` in the `ai` namespace.
export const FLOATING_CHAT_TRANSLATION_KEYS: Record<string, string> = {
  installation: 'installation',
  'driver-registration': 'driver_registration',
  'setup-driver-association': 'setup_driver_association',
  'vehicle-groups': 'vehicle_groups',
  'setup-groups': 'setup_groups',
  checklists: 'checklists',
  'fleet-policies': 'fleet_policies',
  geofences: 'geofences',
  'locais-de-interesse': 'places_of_interest',
  'wifi-configuration': 'wifi_configuration',
  'cam-audio': 'cam_audio',
  'sensibility-configuration': 'sensibility_configuration',
  'user-profiles': 'user_profiles',
};

export const getFloatingChatPrompt = (journeyId: string, t: TFunction): string | undefined => {
  const key = FLOATING_CHAT_TRANSLATION_KEYS[journeyId];
  return key ? (t(`floating_chat_prompts.${key}`) as string) : undefined;
};

export const shouldOpenFloatingChatForRecommendation = ({ forceFloatingChat = false, journeyId }: { forceFloatingChat?: boolean; journeyId: string }) =>
  forceFloatingChat || journeyId in FLOATING_CHAT_TRANSLATION_KEYS;

export const resolveFloatingChatPrompt = ({
  aiPrompt,
  forceFloatingChat = false,
  journeyId,
  t,
}: {
  aiPrompt?: string;
  forceFloatingChat?: boolean;
  journeyId: string;
  t: TFunction;
}) => {
  const floatingChatPrompt = getFloatingChatPrompt(journeyId, t);
  return forceFloatingChat ? (aiPrompt ?? floatingChatPrompt ?? '') : (floatingChatPrompt ?? aiPrompt ?? '');
};
